import { render } from "./UserAccountLoginView.vue?vue&type=template&id=641e7454&scoped=true"
import script from "./UserAccountLoginView.vue?vue&type=script&lang=js"
export * from "./UserAccountLoginView.vue?vue&type=script&lang=js"

import "./UserAccountLoginView.vue?vue&type=style&index=0&id=641e7454&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641e7454"]])

export default __exports__